import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isVenturesOpen, setIsVenturesOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleServices = () => setIsServicesOpen(!isServicesOpen);
  const toggleVentures = () => setIsVenturesOpen(!isVenturesOpen);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-80">
      <div className="container mx-auto px-4 py-4" data-id="element-81">
        <div className="flex justify-between items-center" data-id="element-82">
          <Link to="/" className="text-2xl font-bold text-black" data-id="element-83">
            <span className="text-black" data-id="element-84">Raw</span>
            <span className="text-gray-600" data-id="element-85">founders</span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-86">
            <Link to="/about" className="text-black hover:text-gray-600 font-medium" data-id="element-87">
              About Us
            </Link>
            <div className="relative" data-id="element-88">
              <button onClick={toggleServices} className="flex items-center text-black hover:text-gray-600 font-medium" data-id="element-89">
                Services
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-90" />
              </button>
              {isServicesOpen && <div className="absolute top-full left-0 mt-2 w-60 bg-white shadow-lg rounded-md py-2 z-50" data-id="element-91">
                  <div className="px-4 py-2 text-sm text-gray-500 border-b" data-id="element-92">
                    Our Services
                  </div>
                  <Link to="/rawfound-properties" className="block px-4 py-2 text-sm text-black hover:bg-gray-50" onClick={() => setIsServicesOpen(false)} data-id="element-93">
                    Rawfound Properties
                  </Link>
                </div>}
            </div>
            <div className="relative" data-id="element-94">
              <button onClick={toggleVentures} className="flex items-center text-black hover:text-gray-600 font-medium" data-id="element-95">
                Ventures
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-96" />
              </button>
              {isVenturesOpen && <div className="absolute top-full left-0 mt-2 w-60 bg-white shadow-lg rounded-md py-2 z-50" data-id="element-97">
                  <div className="px-4 py-2 text-sm text-gray-500 border-b" data-id="element-98">
                    Our Ventures
                  </div>
                  <Link to="/shoplinky" className="block px-4 py-2 text-sm text-black hover:bg-gray-50" onClick={() => setIsVenturesOpen(false)} data-id="element-99">
                    Shoplinky
                  </Link>
                  <Link to="/agentter" className="block px-4 py-2 text-sm text-black hover:bg-gray-50" onClick={() => setIsVenturesOpen(false)} data-id="element-100">
                    Agentter.ai
                  </Link>
                </div>}
            </div>
            <Link to="/contact" className="text-black hover:text-gray-600 font-medium" data-id="element-101">
              Contact
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden text-black" onClick={toggleMenu} data-id="element-102">
            {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-103" /> : <MenuIcon className="h-6 w-6" data-id="element-104" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden mt-4 space-y-3" data-id="element-105">
            <Link to="/about" className="block py-2 text-black hover:text-gray-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-106">
              About Us
            </Link>
            <div data-id="element-107">
              <button onClick={toggleServices} className="flex items-center py-2 text-black hover:text-gray-600 font-medium w-full" data-id="element-108">
                Services
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-109" />
              </button>
              {isServicesOpen && <div className="pl-4 space-y-2 mt-2" data-id="element-110">
                  <Link to="/rawfound-properties" className="block py-1 text-black hover:text-gray-600" onClick={() => setIsMenuOpen(false)} data-id="element-111">
                    Rawfound Properties
                  </Link>
                </div>}
            </div>
            <div data-id="element-112">
              <button onClick={toggleVentures} className="flex items-center py-2 text-black hover:text-gray-600 font-medium w-full" data-id="element-113">
                Ventures
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-114" />
              </button>
              {isVenturesOpen && <div className="pl-4 space-y-2 mt-2" data-id="element-115">
                  <Link to="/shoplinky" className="block py-1 text-black hover:text-gray-600" onClick={() => setIsMenuOpen(false)} data-id="element-116">
                    Shoplinky
                  </Link>
                  <Link to="/agentter" className="block py-1 text-black hover:text-gray-600" onClick={() => setIsMenuOpen(false)} data-id="element-117">
                    Agentter.ai
                  </Link>
                </div>}
            </div>
            <Link to="/contact" className="block py-2 text-black hover:text-gray-600 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-118">
              Contact
            </Link>
          </nav>}
      </div>
    </header>;
}